import React, { useState, useRef, useEffect } from "react";
// import config from "../../assets/config.json";
import styles from "./DefineMyCommunity.module.scss";
import {
  CalciteBlock,
  CalciteIcon,
  CalciteLabel,
  CalciteButton,
  CalciteSlider,
} from "@esri/calcite-components-react";
import ClearResultsButton from "./ClearResultsButton/ClearResultsButton";
import DownloadResultsButton from "./DownloadResultsButton/DownloadResultsButton";
import config from '../../assets/config.json'
import Search from "@arcgis/core/widgets/Search";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import Geometry from "@arcgis/core/geometry/Geometry";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
// import LocatorSearchSource from "@arcgis/core/widgets/Search/LocatorSearchSource";

type NavigatorWithMsSaveBlob = Navigator & {
  msSaveBlob?: (blob: Blob, defaultName?: string) => boolean;
};
let activeSearchSource: string = "Address/Coordinate";
let sliderValue: number = 0.5;
const DefineMyCommunity = (props) => {
  // Active cleanup clauses from BasicCleanupsFilter (via MenuPanel) for future query composition.
  const cleanupParamArray = props.cleanupParamArray;
  const advancedCleanupParamArray = props.advancedCleanupParamArray;
  const advancedCleanupMatchesAny = props.advancedCleanupMatchesAny !== false;
  const activeCleanupFilterType = props.activeCleanupFilterType;
  const basicCleanupFilterDescription: string = props.basicCleanupFilterDescription || "no filter applied";
  const advancedCleanupFilterDescription: string = props.advancedCleanupFilterDescription || "no advanced filter applied";
  // const [sliderValue, setSliderValue] = useState<number>(1);
  const [lastSelectedResult, setLastSelectedResult] = useState<any>(null);
  const [shouldShowSlider, setShouldShowSlider] = useState<boolean>(true);
  const [isDownloadReady, setIsDownloadReady] = useState<boolean>(false);
  const ourSlider = useRef(null);
  const searchWidgetDiv = useRef(null);
  // const [brownfieldLayer] = useState<any>(props.webmap.layers.find(layer => layer.title === 'Brownfield Grant Jurisdictions'));
  const [brownfieldLayer] = useState<any>(props.webmap.layers.find(
    (e) => e.allLayers && e.allLayers.items.find(
      (p: any) => p.title === config.layerNames.brownfieldLayer.title
    )
  )
    .allLayers.items.find(
      (p: any) => p.title === config.layerNames.brownfieldLayer.title
    )
  );
  // const [sitesLayer] = useState<any>(props.webmap.layers.find(layer => layer.title === 'Sites'));
  const [sitesLayer] = useState<any>(props.webmap.layers.items.find(
    (e) => e.allLayers && e.allLayers.items.find(
      (p: any) => p.title === config.layerNames.sitesLayer.title
    )
  )
    .allLayers.items.find(
      (p: any) => p.title === config.layerNames.sitesLayer.title
    )
  );

  const [searchWidget] = useState<Search>(
    new Search({
      view: props.view,
      sources: props.sourcesForSearching,
      includeDefaultSources: false,
      searchAllEnabled: false,
      suggestionsEnabled: true,
      resultGraphicEnabled: true,
      activeSourceIndex: 0,
      minSuggestCharacters: 1,
      maxSuggestions: 1000
    })
  );

  if (!searchWidget.hasEventListener('search-complete')) {
    searchWidget.on("search-complete", async (event) => {
      if (event.results.length >= 1) {
        if (event.results[0].results.length >= 1) {
          const topResult = event.results[0].results[0].feature;
          if (searchWidget.activeSource.name === "Brownfield Grant Info") {
            // do things
            const query = brownfieldLayer.createQuery();
            query.where = `JURISDICTION_ID = ${topResult.attributes.JURISDICTION_ID}`;
            query.returnGeometry = true;
            query.maxAllowableOffset = 500;
            brownfieldLayer
              .queryFeatures(query)
              .then(function (response) {
                let selectedResult = {
                  feature: { geometry: response.features[0].geometry },
                };
                let searchGraphic = drawShape(selectedResult);
                setLastSelectedResult(selectedResult);
                props.view.graphics.removeAll();
                props.view.graphics.add(searchGraphic);
                props.view.extent = response.features[0].geometry.extent;
              })
              .catch((e) => {
                console.error("error occured during query, ", e);
              });
            // set searchTerm to agreement number
            searchWidget.searchTerm =
              topResult.attributes.COOPERATIVE_AGREEMENT_PC;
          } else if (searchWidget.activeSource.name === "Cleanup Name") {
            const query = sitesLayer.createQuery();
            query.where = `REGISTRY_ID = '${topResult.attributes.REGISTRY_ID}'`;
            query.returnGeometry = true;
            sitesLayer
              .queryFeatures(query)
              .then(function (response) {
                if (response.features.length === 0) {
                  props.showAlert?.('No features found for this cleanup name.');
                  return;
                } else {
                  let selectedResult = {
                    feature: { geometry: response.features[0].geometry },
                  };
                  let searchGraphic = drawCircle(selectedResult);
                  setLastSelectedResult(selectedResult);
                  props.view.graphics.removeAll();
                  props.view.graphics.add(searchGraphic);
                  props.view.goTo({
                    center: [
                      response.features[0].geometry.longitude,
                      response.features[0].geometry.latitude,
                    ],
                    zoom: 15,
                  });
                }
              })
              .catch((e) => {
                console.error("error occured during query, ", e);
              });
            searchWidget.searchTerm = topResult.attributes.ALTERNATIVE_NAME;
          }
        }
      }
      // toggle layer visibility if it is a point layer that is not on by default
      const activeSource: any = searchWidget.activeSource;
      if (activeSource.layer && activeSource.layer.geometryType === 'point') {
        activeSource.layer.visible = true;
        if (activeSource.layer.parent) {
          activeSource.layer.parent.visible = true;
        }
      }
    });
  }

  if (!searchWidget.hasEventListener('select-result')) {
    searchWidget.on("select-result", () => {
      setIsDownloadReady(true);
      props.view.graphics.removeAll();
      let selectedResult = searchWidget.selectedResult;
      // set lastSelectedResult to use in the radiusSliderChange function
      setLastSelectedResult(selectedResult);
      let searchGraphic;
      if (
        activeSearchSource !== "Address/Coordinate" &&
        activeSearchSource !== "DOE Legacy Management Site"
      ) {
        searchGraphic = drawShape(selectedResult);
      } else if (
        activeSearchSource === "Address/Coordinate" ||
        activeSearchSource === "DOE Legacy Management Site" ||
        activeSearchSource === "Cleanup Name" ||
        activeSearchSource === "EPA Facility Registry or Program ID"
      ) {
        searchGraphic = drawCircle(selectedResult);
        if (
          searchWidget.activeSource.name ===
          "EPA Facility Registry or Program ID"
        ) {
          searchWidget.searchTerm =
            selectedResult.feature.attributes.PRIMARY_NAME;
        }
      }
      props.view.graphics.add(searchGraphic);
    });
  }

  if (!searchWidget.hasEventListener('search-clear')) {
    searchWidget.on("search-clear", () => {
      setIsDownloadReady(false);
      setLastSelectedResult(null);
      props.view.graphics.removeAll();
    });
  }

  // called when a non-Address/Coordinate search-result is selected
  // renders the selected-results geometries on the map
  const drawShape = (selectedResult) => {
    let searchGraphic = new Graphic();
    let simplifiedShape = geometryEngine.simplify(
      selectedResult.feature.geometry
    );
    searchGraphic = new Graphic({
      geometry: simplifiedShape as Geometry,
      // geometry: searchWidget.selectedResult.feature.geometry as Geometry,
      symbol: new SimpleFillSymbol({
        color: [173, 173, 173, 0.5],
      }),
      attributes: {
        name: "define-my-community"
      }
    });
    return searchGraphic;
  };

  // called when an Address/Coordinate search-result is selected and when the radius slider changes value,
  // draws a circle on the map with the specified radius from the radius slider
  const drawCircle = (selectedResult, newSliderValue?) => {
    let radiusValueToUse = sliderValue;
    if (newSliderValue) {
      radiusValueToUse = newSliderValue;
    }
    const ptBuff = geometryEngine.geodesicBuffer(
      selectedResult.feature.geometry,
      radiusValueToUse,
      "miles"
    );
    const ptAsAny: any = ptBuff;
    if (ptAsAny.extent) {
      props.view.extent = ptAsAny.extent;
    }
    let searchGraphic = new Graphic({
      geometry: ptBuff as Geometry,
      symbol: new SimpleFillSymbol({
        color: [173, 173, 173, 0.5],
      }),
      attributes: {
        name: "define-my-community"
      }
    });
    return searchGraphic;
  };
  const [signalSourceChange, setSignalSourceChange] = useState<Number>(Math.random());

  const [classToUse, setClassToUse] = useState<string>('littleBox');
  // called every time the searchWidget is clicked
  const searchWidgetClicked = () => {
    // update activeSearchSource to be equal to searchWidget's active source
    if (activeSearchSource !== searchWidget.activeSource.name) {
      setSignalSourceChange(Math.random());
      // setActiveSearchSource(searchWidget.activeSource.name);
      activeSearchSource = searchWidget.activeSource.name;
    }
    if (['Address/Coordinate', 'Cleanup Name', 'DOE Legacy Management Site', 'EPA Facility Registry or Program ID'].find(s => s === activeSearchSource)) {
      setShouldShowSlider(true);
    } else setShouldShowSlider(false);
    // disable location search if address/coordinate isn't selected, otherwise make it false
    if (searchWidget.activeSource.name === "Address/Coordinate") {
      searchWidget.locationEnabled = true;
    } else {
      searchWidget.locationEnabled = false;
    }

  };

  const checkMenu = () => {
    if (['suggestion', 'source'].find(s => s === searchWidget.activeMenu)) {
      setClassToUse('bigBox');
    } else { setClassToUse('littleBox'); }
  }

  // called whenever the radius slider changes value,
  // updates sliderValue and re-draws the circle ONLY IF one has already been drawn
  const radiusSliderChange = (event) => {
    if (event.target.value === 0) {
      // just remove the circle. it will be re-drawn when radius slider value is greater than 1
      setIsDownloadReady(false);
      props.view.graphics.removeAll();
    } else {
      // the radius slider value is greater than 0
      // setSliderValue(event.target.value);
      sliderValue = event.target.value;
      let newSliderValue = event.target.value;
      let newCircle;
      // draw the selectedResult if it isn't null, otherwise draw the lastSelectedResult
      if (searchWidget.selectedResult !== null) {
        newCircle = drawCircle(searchWidget.selectedResult, newSliderValue);
        setIsDownloadReady(true);
      } else if (searchWidget.selectedResult === null && lastSelectedResult) {
        newCircle = drawCircle(lastSelectedResult, newSliderValue);
      }
      // remove previously drawn graphics and add the new circle
      props.view.graphics.removeAll();
      props.view.graphics.add(newCircle);
    }
  };

  // clear graphics off map and clear text from search widget
  const handleClear = () => {
    setIsDownloadReady(false);
    searchWidget.clear();
    // setLastSelectedResult(null);
    props.view.graphics.removeAll();
  };

  const downloadResults = () => {
    if (!isDownloadReady) {
      props.showAlert?.('Make an address or search area selection first.');
      return
    } 
    const query = sitesLayer.createQuery();
    let cleanupWhere = "1=1";
    if (activeCleanupFilterType === 'advanced') {
      if (Array.isArray(advancedCleanupParamArray) && advancedCleanupParamArray.length > 0) {
        const advancedJoiner = advancedCleanupMatchesAny ? " OR " : " AND ";
        cleanupWhere = `(${advancedCleanupParamArray.join(advancedJoiner)})`;
      } else {
        cleanupWhere = "1=0";
      }
    } else if (activeCleanupFilterType === 'basic') {
      cleanupWhere = Array.isArray(cleanupParamArray) && cleanupParamArray.length > 0 ? `(${cleanupParamArray.join(") OR (")})` : "1=0";
    }
    query.geometry = props.view.graphics.items[0].geometry;
    query.spatialRelationship = "intersects";
    query.where = cleanupWhere;
    query.outFields = ['*'];
    sitesLayer.queryFeatures(query).then((response) => {
      if (response.features.length === 0) {
        props.showAlert?.('No features found within the community to download.');
        return;
      } else {
        const attr = response.features.map(a => a.attributes);
        let headers = {};
        const entry = attr[0];
        for (let k in entry) {
          if (entry.hasOwnProperty(k)) {
            headers[k] = k
          }
        }
        exportCSVFile(headers, attr, "CIMC_Sites_Export")
      }
    })
    .catch((e) => {
      console.error("error occured during query, ", e);
    });
  }

  // export functions
  // https://medium.com/@danny.pule/export-json-to-csv-file-using-javascript-a0b7bc5b00d2
  function convertToCSV(items) {
    return items
      .map((item) =>
        Object.keys(item)
          .map((key) => escapeCsvCell(item[key]))
          .join(",")
      )
      .join("\r\n");
  }

  /**
   * Escapes a value for safe placement in a single CSV cell.
   * Keep the description/header text in one spreadsheet cell
   * even when it contains commas or double quotes.
   */
  const escapeCsvCell = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    let stringValue = String(value);

    // Prevent spreadsheet formula injection when opened in Excel/Sheets.
    if (/^[=+\-@]/.test(stringValue)) {
      stringValue = `'${stringValue}`;
    }

    // Escape double quotes by doubling them, then quote every cell.
    return `"${stringValue.replace(/"/g, '""')}"`;
  };

  function exportCSVFile(headers, items, fileTitle) {
    const rows = headers ? [headers, ...items] : items;
    // csv should include a header with details about the export, i.e.

    // Cleanups in My Community Sites within {radius} miles of {address 
    // or coordinate} matching the query {applied filter} exported on {date}

    // Cleanups in My Community Sites in {feature name} from {layer name} 
    // matching the query {no filter applied} exported on {date}
    const now = new Date();
    const dateTime = now.toLocaleString()
    const selectedFiltersText = basicCleanupFilterDescription;
    const advancedFilterText = advancedCleanupFilterDescription && advancedCleanupFilterDescription.trim() !== ""
      ? advancedCleanupFilterDescription
      : "no advanced filter applied";
    const combinedFiltersText = `basic: ${selectedFiltersText}; advanced: ${advancedFilterText}`;
    let csvPrefix = "";
    if (activeSearchSource === "Address/Coordinate") {
      const selectedNameForAddress =
        lastSelectedResult?.name || searchWidget.selectedResult?.name || searchWidget.searchTerm || "selected location";
      const descriptionRow = `Cleanups in My Community Sites within ${sliderValue} miles of ${selectedNameForAddress} matching filters: ${combinedFiltersText}. Exported on ${dateTime}.`;
      csvPrefix = `${escapeCsvCell(descriptionRow)}\r\n\r\n`;
    } else if (activeSearchSource) {
      const selectedResultForDescription = searchWidget.selectedResult || lastSelectedResult;
      const selectedFeatureName =
        selectedResultForDescription?.name ||
        selectedResultForDescription?.feature?.attributes?.PRIMARY_NAME ||
        selectedResultForDescription?.feature?.attributes?.ALTERNATIVE_NAME ||
        selectedResultForDescription?.feature?.attributes?.COOPERATIVE_AGREEMENT_PC ||
        searchWidget.searchTerm ||
        "selected feature";
      const selectedLayerName =
        searchWidget.activeSource?.name ||
        activeSearchSource ||
        "selected layer";
      const descriptionRow = `Cleanups in My Community Sites in ${selectedFeatureName} from ${selectedLayerName} matching the filter ${combinedFiltersText} exported on ${dateTime}.`;
      csvPrefix = `${escapeCsvCell(descriptionRow)}\r\n\r\n`;
    }

    const csv = csvPrefix + convertToCSV(rows); 
    // Make meaningful download name
    const exportedFilename = fileTitle + ".csv";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const nav = navigator as NavigatorWithMsSaveBlob;

    if (typeof nav.msSaveBlob === "function") {
      // for Internet Explorer
      nav.msSaveBlob(blob, exportedFilename);
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    }
  }

  // called when one of the US buttons are clicked, changes map extent to fit either the entire US or lower 48 states
  const jumpToUSExtents = (whereToJump) => {
    let extentClicked = whereToJump.target.outerText;
    if (extentClicked === "Entire US") {
      props.view.extent = {
        xmin: -19127449.89,
        xmax: -9402213.9,
        ymin: 1918603.6,
        ymax: 11546000.19,
        spatialReference: new SpatialReference({ wkid: 102100 }),
      };
    } else if (extentClicked === "Lower 48") {
      props.view.extent = {
        xmin: -14551929.45,
        xmax: -7497708.98,
        ymin: 2253932.55,
        ymax: 7067630.84,
        spatialReference: new SpatialReference({ wkid: 102100 }),
      };
    }
  };

  useEffect(() => {
    if (searchWidgetDiv.current && !searchWidget.container) {
      searchWidget.container = searchWidgetDiv.current;
    }
  });

  useEffect(() => { }, [props.view, props.sourcesForSearching, lastSelectedResult, sitesLayer, brownfieldLayer, shouldShowSlider, signalSourceChange, classToUse, cleanupParamArray, basicCleanupFilterDescription]);
  // useEffect(() => {}, [sliderValue, lastSelectedResult, sitesLayer, brownfieldLayer, shouldShowSlider, signalSourceChange]);

  return (
    <div onBlur={() => { checkMenu(); }} className={styles.mainDiv} onClick={() => { checkMenu(); }}>
      <CalciteBlock
        heading="Define Your Community"
        description="Show map data within your community"
        collapsible
        open
      >
        <CalciteIcon scale="m" slot="icon" icon="information"></CalciteIcon>
        <div className={styles.FormCanvas}>
          <div>
            <CalciteBlock
              className={styles.FormGroup}
              heading={"Search by " + activeSearchSource}
            ></CalciteBlock>
            <CalciteLabel className={styles.InputLabel}>
              {" "}
              {/* {"Search by " + activeSearchSource} */}
            </CalciteLabel>

            <div className={styles.searchWidgetDiv} onClick={searchWidgetClicked} ref={searchWidgetDiv} />

            {classToUse === 'littleBox' && <div className={styles.littleBox}>
              {activeSearchSource === "EPA Info" && (
                <p>Search by Cleanup Name, EPA Registry ID, Program ID</p>
              )}
            </div>}
            {classToUse === 'bigBox' && <div className={styles.epaInfoDiv}>
              {activeSearchSource === "EPA Info" && (
                <p>Search by Cleanup Name, EPA Registry ID, Program ID</p>
              )}
            </div>}

            <div className={styles.sliderStyle}>
              {(shouldShowSlider) && (
                <CalciteLabel className={styles.InputLabel}>
                  {"Change Radius (mi)"}
                </CalciteLabel>
              )}

              {(shouldShowSlider) && (
                <CalciteSlider
                  className={styles.sliderStyle}
                  onCalciteSliderChange={(event) => {
                    radiusSliderChange(event);
                  }}
                  ref={ourSlider}
                  min={0}
                  minValue={0.5}
                  max={15}
                  ticks={5}
                  snap={true}
                  value={sliderValue}
                  labelHandles={true}
                  step={0.5}
                />
              )}
            </div>

            <div className={styles.buttonDiv}>
              <ClearResultsButton handleClick={handleClear} />
              <DownloadResultsButton
                handleClick={downloadResults}
                kind={isDownloadReady ? "brand" : "neutral"}
              />
              <CalciteButton
                className={styles.buttons}
                onClick={(event) => {
                  jumpToUSExtents(event);
                }}
              >
                {"Entire US"}
              </CalciteButton>
              <CalciteButton
                className={styles.buttons}
                onClick={(event) => {
                  jumpToUSExtents(event);
                }}
              >
                {"Lower 48"}
              </CalciteButton>
            </div>
          </div>
          <p>
            <a href="https://cimc.epa.gov/ords/cimc/f?p=CIMC:LIST" target="_blank" rel="noreferrer">
              List Cleanups and Grants Page
            </a>{" "}
          </p>
        </div>
      </CalciteBlock>
    </div>
  );
};

export default DefineMyCommunity;
